import React from "react";

export const ButtonSize = {
    DEFAULT: '',
    SMALL: ' btn-sm',
    LARGE: ' btn-lg',
}

export const ButtonDirection = {
    DEFAULT: '',
    LEFT: ' left',
    RIGHT: ' right',
}

export const ButtonOption = {
    DEFAULT: '',
    PRIMARY: " btn-primary",
    DESTRUCTIVE: " btn-destructive",
    PRIMARY_DESTRUCTIVE: " btn-primary btn-destructive",
}

export const Button = ({ children, onClick, disabled, option = ButtonOption.DEFAULT, size = ButtonSize.SMALL, direction = ButtonDirection.DEFAULT, className = '' }) => {
    return <button type="button" disabled={disabled} className={`btn${option}${size}${direction}${className ? ` ${className}` : ''}`} onClick={onClick}>
        {children}
    </button>
}